import {Injectable} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Map} from 'leaflet';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  private _map: Map;
  private _mapSubject = new ReplaySubject<Map>(1);
  mapReady$ = this._mapSubject.asObservable();

  constructor() {
  }

  get map(): Map {
    return this._map;
  }

  set map(value: Map) {
    this._map = value;
    this._mapSubject.next(value);
  }
}
